import { useItemsFine } from "../actions/app/items";
import log from "cslog";
import { useState } from "react";
import IdeaCanvasModal from "../content_calender_new/IdeaCanvasModal";
import { Card, Button, Row, Col, Image, Typography } from "antd";
import { getImageURL, getPublicImageURL } from "../_helpers/image";
import styles from "./styles/RecentDesign.module.css";
import { useMedia } from "react-use";
import { SingleItem } from "../qmade/creator/SingleItem";
import { getViewerURL } from "../_helpers/editor";
import sample_img from "../media/imgs/website_skelton.jpg";
import IdeaCanvasBox from "../content_calender_new/IdeaCanvasBox";
import { startCase, template } from "lodash";
import { GlobalOutlined, TwitterCircleFilled } from "@ant-design/icons";

const { Title } = Typography;

function RecentDesign({ me = {} }) {
    const isMobile = useMedia("(max-width: 700px)");
    const { isLoading, isSuccess, data } = useItemsFine(
        "qdb_creation_history",
        // "fields=*,design_template.preview,design_template.title",
        "filter[user_created][_eq]=$CURRENT_USER&sort=-date_created&limit=24&fields=*,design_template.preview,design_template.title,design_template.id,used_schemas.qdb_creation_schema_id",
        true,
        false,
        true
    );

    const [open, setOpen] = useState(false);
    const [selectedCard, setSelectedCard] = useState(null);

    if (isLoading) {
        return <div className="recent-design">Loading...</div>;
    }

    log.d(data, "Recent Designs Data");

    const handleCardClick = (item) => {
        setSelectedCard(item);
        setOpen(true);
        log.d(item, "Selected Card");
    };

    if (isSuccess && data?.data?.length === 0) {
        return <></>;
    }

    return (
        <div className={styles.wrapper}>
            <Title
                level={5}
                type="secondary"
                style={{ textTransform: "uppercase", marginBottom: "15px" }}
            >
                Recent Designs
            </Title>

            {isSuccess && data?.data?.length === 0 && (
                <p>No recent designs available.</p>
            )}

            <div
                // className={isMobile ? styles.grid_wrapper_mobile : styles.gridWrapper}
                className={styles.gridWrapper}
            >
                {isSuccess &&
                    data?.data?.length > 0 &&
                    data?.data?.map((item, index) => {
                        if (
                            ["tweet", "blog_post"].includes(item.content_type)
                        ) {
                            return (
                                <PlaceholderCard
                                    key={item.id}
                                    item={{
                                        id: item.id,
                                        title: startCase(item.content_type),
                                        type: item.content_type,
                                    }}
                                    onClick={() => handleCardClick(item)}
                                />
                            );
                        }
                        return (
                            <OneCard
                                key={item.id}
                                item={{
                                    id: item.id,
                                    preview: item.design_template?.preview,
                                    title: item.design_template?.title,
                                }}
                                onClick={() => handleCardClick(item)}
                            />
                        );
                    })}
                {/* {selected_item && (
                    <PreviewTemplate
                        item={selected_item}
                        open={open}
                        setOpen={setOpen}
                        is_template={false}
                        slug_field="slug"
                        enable_img_preview={false}
                        me={me}
                        isMobile={isMobile}
                        preset={preset}
                    />
                )}
                {selected_creations.length > 0 && (
                    <SelectionBar
                        selected_creations={selected_creations}
                        setSelectedCreations={setSelectedCreations}
                        user={user}
                    />
                )} */}
            </div>

            {selectedCard && (
                <IdeaCanvasBox
                    key={selectedCard.id}
                    open={open}
                    setOpen={setOpen}
                    data={{
                        // ...(typeof selectedCard === "object" ? selectedCard : {}),
                        ...(selectedCard || {}),
                        status: "generated",
                        generated_data: {
                            canvas: {
                                design: {
                                    preset_id:
                                        selectedCard?.used_schemas?.[0]
                                            ?.qdb_creation_schema_id,
                                    template_id:
                                        selectedCard?.design_template?.id,
                                    prefill:
                                        selectedCard?.generated_content?.canvas
                                            ?.design?.prefill || {},
                                    // prefill: selectedCard?.generated_content?.data || {},
                                },
                                // design: {
                                //     preset_id: selectedCard?.used_schemas?.[0]?.qdb_creation_schema_id,
                                //     template_id: selectedCard?.design_template?.id,
                                //     prefill: {
                                //         "fact": {
                                //             "fact": "Hello preset htere"
                                //         }
                                //     }
                                // }
                            },
                        },
                    }}
                    me={me}
                />
            )}
        </div>
    );
}

export default RecentDesign;

function OneCard({ item, onClick }) {
    return (
        <div className={styles.one_card_wrapper} onClick={onClick}>
            <img
                src={
                    item.preview ? getPublicImageURL(item.preview) : sample_img
                }
            />
            <p>{item.title}</p>
        </div>
    );
}

const ICON_MAPPING = {
    tweet: (
        <TwitterCircleFilled style={{ color: "#1DA1F2", fontSize: "50px" }} />
    ),
    blog_post: (
        <GlobalOutlined style={{ color: "#000000", fontSize: "50px" }} />
    ),
};

const COLOR_MAPPING = {
    tweet: "#1da0f244",
    blog_post: "#00000025",
};

function PlaceholderCard({ item, onClick }) {
    return (
        <div className={styles.one_card_wrapper} onClick={onClick}>
            <div
                style={{
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: COLOR_MAPPING[item?.type],
                }}
            >
                {ICON_MAPPING[item?.type]}
            </div>
            <p>{item.title}</p>
        </div>
    );
}
